// queue #658 §UAT-2026-07-08-R658 §R658-2②: module-maturity.json(read-only, §R643 산출물)
// re-export 를 위한 static import — 다른 export 문 앞(top-level)에 배치.
import moduleMaturityJson from './data/module-maturity.json';
import type { ModuleMaturity as ModuleMaturityType } from './types/showcase';

// Pages
export { CommonShowcasePage } from './pages/CommonShowcasePage';
// queue #663 §UAT-2026-07-09-R663: 피드백/문의 관리 — ROLE_ADMIN 전용(router.tsx AdminRouteGuard)
export { FeedbackAdminPage } from './pages/FeedbackAdmin.page';
// queue #687 §UAT-2026-07-14-R687: 채택 현황 관리 — ROLE_ADMIN 전용(router.tsx AdminRouteGuard)
export { AdoptionStatsPage } from './pages/AdoptionStats.page';

// Hooks (public API)
export { useModuleCatalog } from './hooks/useModuleCatalog';
export { useValidateDemo } from './hooks/useValidateDemo';
export { useMaskDemo } from './hooks/useMaskDemo';
export { useExcelDemo } from './hooks/useExcelDemo';
export { useEventDemo } from './hooks/useEventDemo';
export { useErrorDemo } from './hooks/useErrorDemo';
export { useFileDemo } from './hooks/useFileDemo';
export { useCacheDemo } from './hooks/useCacheDemo';
// queue #662 §R662-3: 다운로드 집계 훅 — _index '인기 모듈' 카드가 소비(단방향 _index → common-showcase)
export { useDownloadStats } from './hooks/useDownloadStats';
// queue #663 §UAT-2026-07-09-R663: 피드백/문의 채널 훅
// queue #684 §UAT-2026-07-14-R684: 답변 회신(useAnswerFeedback) + 본인 문의 조회(useMyFeedback) 추가
export { useSubmitFeedback } from './hooks/useSubmitFeedback';
export { useFeedbackList } from './hooks/useFeedbackList';
export { useMyFeedback } from './hooks/useMyFeedback';
export { useAnswerFeedback } from './hooks/useAnswerFeedback';
// queue #677 §UAT-2026-07-13-R677: 모듈 구독(워치) — _index WatchedChangesCard 가 소비
export { useWatches } from './hooks/useWatches';

// Components (new)
export { UtilityPanel } from './components/UtilityPanel';
export { CryptoPanel } from './components/CryptoPanel';
export { JpaPanel } from './components/JpaPanel';

// queue #658 §UAT-2026-07-08-R658 §R658-2②: 전역 변경 피드 — 순수 셀렉터+타입만 public
// re-export(cross-feature 심층 결합 회피). _index 대시보드 카드(RecentModulesCard)가 소비.
export { selectRecentModules } from './data/recent-changes';
export type { ChangeEntry, RecentModule } from './data/recent-changes';
export type { ModuleMaturity } from './types/showcase';
// queue #662 §R662-3: 집계 응답 타입 — _index '인기 모듈' 카드가 소비
// queue #678 §R678-3: ByModuleCount → ModuleScore(하위호환 별칭) — 복합점수/타입별 카운트 additive
export type { DownloadStatsResponse, ByModuleCount, ModuleScore } from './types/showcase';
// queue #677 §UAT-2026-07-13-R677 §R677-4③: '내 구독 모듈 최근 변경' 위젯 — 순수 셀렉터+타입만
// public re-export(cross-feature 심층 결합 회피 · §R658 계보). _index WatchedChangesCard 가 소비.
export { selectWatchedRecentChanges } from './data/recent-changes';
export type { WatchedChangeEntry } from './data/recent-changes';
export type { WatchListResponse } from './types/showcase';
/** §R643 이 커밋한 module-maturity.json(read-only) — _index 카드가 selectRecentModules 와 함께 소비 */
export const moduleMaturity = moduleMaturityJson as unknown as ModuleMaturityType;

// queue #675 §UAT-2026-07-13-R675: 쿡북 레시피 SSOT — project-scaffold 프리셋 카드가 소비
// (pure 정적 데이터+순수 셀렉터만 public re-export · cross-feature 심층 결합 회피 · §R658 계보)
export { RECIPES, recipeModuleCodes } from './data/recipes';
export type { Recipe, RecipeModuleRef } from './data/recipes';
